import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Introduction to Automation Testing (Tools, Frameworks, Best Practices)",
  "Selenium WebDriver (Introduction, Element Locators, WebDriver Commands)",
  "TestNG Framework (Test Execution, Annotations, Reporting)",
  "JUnit Framework (Assertions, Test Suites, IDE Integration)",
  "Continuous Integration (Jenkins Integration, Automation Pipelines)",
  "Performance Testing (Using JMeter for Load Testing)",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive hands-on training with expert mentors." },
  { title: "Mock Interview",                 desc: "Score minimum 3.5 out of 5 to progress." },
  { title: "Live Project — 3 Months",        desc: "Work on real industry-grade projects." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Certification and job opening references." },
];
const AutomationTest = () => (
  <CourseDetailTemplate title="Automation Testing Course"
    description="Build your career in Automation Testing! Master core testing tools and frameworks like Selenium, TestNG, and JUnit. Equip yourself to develop and execute automated tests for modern applications."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Selenium", "TestNG", "JUnit", "Jenkins", "JMeter"]}
    programName="Automation Testing Course"
  />
);
export default AutomationTest;
